const carouselData = [
  {
    title: '年度盘点：2026上半年娱乐圈十大未解之谜',
    desc: '从顶流塌房到选秀黑幕，回顾上半年最受关注却仍未水落石出的十大悬案。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20mystery%20concept%20with%20golden%20question%20marks%20and%20crimson%20fog%2C%20dark%20cinematic%20atmosphere%2C%20luxurious%20moody%20lighting%2C%20professional%20noir%20photography%2C%20no%20text%2C%20no%20faces&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '深度专题：直播带货行业信任危机全面爆发',
    desc: '虚假宣传、数据造假、售后缺失——这个千亿级市场正在经历前所未有的信任崩塌。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20ecommerce%20livestream%20studio%20with%20warm%20dramatic%20ring%20light%2C%20dark%20mysterious%20shadows%2C%20cinematic%20atmosphere%2C%20professional%20photography%2C%20no%20faces%2C%20no%20text&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '特别企划：那些年我们追过的塌房明星全记录',
    desc: '从人设完美到一夜崩塌，我们整理了近三年最具代表性的明星翻车事件时间线。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20falling%20stars%20concept%20with%20warm%20golden%20and%20crimson%20streaks%2C%20dark%20night%20sky%2C%20cinematic%20moody%20atmosphere%2C%20luxurious%20texture%2C%20no%20text%2C%20no%20faces&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '独家策划：综艺节目幕后操盘手揭秘',
    desc: '从编剧到剪辑，从选角到营销，全方位解密一档热门综艺是如何被精心"制造"出来的。',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20production%20control%20room%20with%20warm%20monitor%20glows%2C%20dark%20dramatic%20atmosphere%2C%20professional%20broadcast%20equipment%2C%20cinematic%20lighting%2C%20no%20faces%2C%20no%20text&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '行业观察：短视频时代网红生命周期为何越来越短',
    desc: '数据报告显示，2026年头部网红的平均活跃周期已缩短至8个月，背后的流量逻辑令人深思。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20hourglass%20with%20flowing%20golden%20particles%2C%20dark%20tech%20background%2C%20warm%20amber%20and%20crimson%20glow%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20faces&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '焦点关注：AI生成内容对娱乐行业的冲击与机遇',
    desc: '虚拟偶像崛起、AI编剧渗透、深度伪造风险——技术在重塑娱乐圈的游戏规则。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20concept%20with%20glowing%20neural%20networks%20in%20warm%20amber%20and%20crimson%20tones%2C%20dark%20abstract%20background%2C%20cinematic%20sci-fi%20atmosphere%2C%20professional%20style%2C%20no%20text%2C%20no%20faces&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">编辑团队精心策划的深度专题内容</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200 transition-colors"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-accent-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}